import { FiatCurrency } from '../shared/finance';

import { Environment } from './environment.abstraction';

export const environment: Environment = {
  production: false,
  apiHost: 'https://api.busaas-dev.top',
  defaultLang: 'en',
  notificationsPollingIntervalMs: 20_000,
  sourceMap: true,
  supportedUiLanguages: ['en'],
  theme: 'light',
  defaultCurrency: FiatCurrency.EUR,
};
